export default __webpack_public_path__ + "static/media/Helm of the Savage Slaughter.712b5661.jpg";